import { isAfter } from 'date-fns';

/**
 * Checks if the stored token is expired.
 */
export const isTokenExpired = (): boolean => {
    const tokenExpiresStr = localStorage.getItem('token_expires');

    if (!tokenExpiresStr) {
        return true;
    }

    const tokenExpires = new Date(tokenExpiresStr);
    return !isAfter(tokenExpires, new Date());
};

/**
 * Checks if the user is currently logged in with a valid (non-expired) token.
 */
export const isUserLoggedIn = (): boolean => {
    const storedIsLoggedIn = !!localStorage.is_logged_in;
    return storedIsLoggedIn && !isTokenExpired();
};
